import * as React from 'react';
import Player from 'xgplayer';
import ReactModal from 'react-modal';
import styles from './index.module.scss';
import { Icon } from 'antd-mobile';
import 'xgplayer/dist/xgplayer.min.css';

const XGVideo = ({ url }) => {
  const playerRef = React.useRef(null);

  React.useEffect(() => {
    playerRef.current = new Player({
      id: 'video-player',
      url: url,
      poster: `${url}?x-oss-process=video/snapshot,t_10000,m_fast,w_100,h_180`,
      playsinline: true,
      width: '100%',
      height: '100%',
      controls: true,
      videoInit: true,
    });

    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
      }
    };
  }, []);
  return <div id="video-player" className="video-player"></div>
}

const MyVideo = ({ open, onClose, url }) => {
  return (
    <ReactModal isOpen={open} closeTimeoutMS={250}>
      <section className={styles.playerWrapper}>
        <Icon
          className={styles.iconClose}
          type="cross"
          onClick={onClose}
        />
        <XGVideo url={url} />
      </section>
    </ReactModal>
  );
};

export default MyVideo;
